import { render, staticRenderFns } from "./DayDurations.vue?vue&type=template&id=8aea93be&"
import script from "./DayDurations.vue?vue&type=script&lang=js&"
export * from "./DayDurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports